import { render, staticRenderFns } from "./EmptyError.vue?vue&type=template&id=216c12ca&scoped=true&"
import script from "./EmptyError.vue?vue&type=script&lang=js&"
export * from "./EmptyError.vue?vue&type=script&lang=js&"
import style0 from "./EmptyError.vue?vue&type=style&index=0&id=216c12ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216c12ca",
  null
  
)

export default component.exports